<template>
    <div>
        <div class="flex flex-col card px-5 mb-10 md:mb-0">
            <div class="flex">
                <div class="px-10 py-5 md:p-10 text-center w-full">
                    <h1 class="font-light">Cartão de crédito</h1>
                </div>
            </div>

            <div v-if="loading" class="w-full p-20">
                <div class="loader"></div>
            </div>

            <div v-if="!loading && !brand">
                <button class="btn btn-orange" @click="selectBrand('others')">
                    Cartões Visa, Mastercard, AMEX, JCB, Diners, Aura, Discover
                </button>

                <button class="btn btn-orange mt-5" @click="selectBrand('elo,hiper')">
                    Cartões Elo e Hipercard
                </button>
            </div>

            <div v-show="showDefaultForm">
                <input type="text"
                       class="input w-full mb-5"
                       name="name"
                       autocomplete="cc-name"
                       v-model="card.name"
                       placeholder="Nome (como escrito no cartão)">

                <input type="text"
                       class="input w-full"
                       name="number"
                       autocomplete="cc-number"
                       v-model="card.number"
                       v-maska
                       data-maska="#### #### #### ####"
                       placeholder="Número do cartão">

                <div class="w-full flex">
                    <input type="text"
                           class="input w-full mr-5"
                           name="expiry"
                           autocomplete="cc-exp"
                           v-model="card.expiry"
                           v-maska
                           data-maska="## / ####"
                           placeholder="MM / AAAA">

                    <input type="number"
                           name="cvc"
                           v-model="card.cvc"
                           autocomplete="cc-csc"
                           class="input w-full"
                           placeholder="Cód. Segurança">
                </div>

                <div class="pb-10">
                    <button class="btn btn-orange" @click="finish()">
                        Finalizar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .card input {
        @apply mb-5;
    }
</style>

<script>
    import {Zapin} from "@/services/Api";

    export default {
        props: {
            plan: String
        },

        data() {
            return {
                brand: null,
                showDefaultForm: false,
                loading: false,
                card: {}
            }
        },

        mounted() {

        },

        methods: {
            finish() {
                this.$emit('finishes', {type: 'card', card: this.card});
            },

            selectBrand(brand) {
                if(brand === 'elo,hiper') {
                    this.showDefault();
                } else {
                    this.openBrowserPayment();
                }
            },

            showDefault() {
                this.brand = 'others';
                this.showDefaultForm = true;
            },

            openBrowserPayment() {
                this.loading = true;

                Zapin
                    .plans()
                    .show(this.plan)
                    .then(res => {
                        this.callPaymentApi(res.data)
                            .then((res) => {
                                if(res.details) {
                                    this.card = {
                                        number: res.details.cardNumber,
                                        name: res.details.cardholderName,
                                        cvc: res.details.cardSecurityCode,
                                        expiry: res.details.expiryMonth + ' / ' + res.details.expiryYear,
                                    }
                                }

                                res.complete();
                                this.finish();
                                this.showDefault();
                            })
                            .catch(() => {
                                this.showDefault();
                            });
                    })
                    .catch(() => {
                        this.showDefault();
                    })
                    .finally(() => this.loading = false);
            },

            callPaymentApi(plan, options = {}) {
                return new Promise((resolve, reject) => {
                    if (window.PaymentRequest) {
                        const methodData = [
                            {
                                supportedMethods: [
                                    'basic-card'
                                ],
                                data: {
                                    supportedNetworks: [
                                        'amex', 'diners', 'discover', 'jcb', 'maestro',
                                        'mastercard', 'visa'
                                    ]
                                }
                            }
                        ];

                        options = Object.assign({
                            requestPayerPhone: false,
                            requestPayerEmail: false,
                            requestPayerName:  false,
                            requestBillingAddress: false,
                            requestShipping: false
                        }, options);

                        const details = {
                            displayItems: [
                                {
                                    label: plan.name,
                                    amount: { currency: plan.currency, value : plan.amount }
                                }
                            ],
                            total:  {
                                label: this.$t('total'),
                                amount: {
                                    currency: plan.currency,
                                    value: plan.amount
                                }
                            }
                        };

                        let request = new window.PaymentRequest(
                            methodData,
                            details,
                            options
                        );

                        request
                            .show()
                            .then((res) => {
                                resolve(res);
                            })
                            .catch(reject);
                    } else {
                        reject('unsupported');
                    }
                })

            }
        }

    }
</script>